import $ from "jquery";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import bdjs from "@bd-core/bdjs";
import bdapi from "@bd-core/bd-api";

export class LeaderboardPage extends BD_Component {
    constructor() {
        super();

        this.id = "leaderboard";
        this.template = "leaderboard-template";

        this.elms = {
            pageScreen: "#leaderboard-page",
            pageToggler: ".js-toggler",
            pageHeader: ".js-leaderboard-header",
            filterToggler: ".js-filter-toggler",
            filterTogglerContainer: ".js-filter-toggler-container",
            // Team overlay elements
            goToJoinTeamBtn: ".js-go-to-join-team",
            viewTeamBtn: ".js-view-team",
            teamDetailPopup: ".js-team-detail-popup",
            joinTeamPopup: ".js-join-team-popup",
            createTeamPopup: ".js-create-team-popup",
            goToCreateTeamBtn: ".js-go-to-create-team",
            backBtn: ".js-back-btn",
            closeCreateTeamBtn: ".js-close-create-team",
            teamNameInput: ".js-team-name-input",
            createConfirmBtn: ".js-create-confirm",
            createConfirmPopup: ".js-create-confirm-popup",
            createBtn: ".js-create-btn",
            closeConfirmBtn: ".js-close-confirm",
            confirmTeamname: ".js-confirm-teamname",
            joinConfirmBtn: ".js-join-confirm",
            joinConfirmPopup: ".js-join-confirm-popup",
            joinBtn: ".js-join-btn",
            leaveTeamBtn: ".js-leave-team",
            leaveTeamPopup: ".js-leave-team-popup",
            leaveTeamConfirmBtn: ".js-leave-team-confirm",
            leaveTeamCancelBtn: ".js-leave-team-cancel",
            removeMemberBtn: ".js-remove-member",
            removeMemberPopup: ".js-remove-member-popup",
            removeMemberConfirmBtn: ".js-remove-member-confirm",
            removeMemberCancelBtn: ".js-remove-member-cancel",
            joinBlockedPopup: ".js-join-blocked-popup",
            closeBlockedBtn: ".js-close-blocked",
            snackbar: ".js-snackbar",
            snackbarText: ".js-snackbar-text",
            snackbarClose: ".js-snackbar-close",
        };

        this._events = this.getEvents();

        this.isFilterActive = true;
        this.countdownInterval = null;
    }

    getEvents() {
        const elms = this.elms;

        return [
            {
                event: "click",
                selector: elms.pageToggler,
                handler: this.onSwitchTab,
            },      
            {
                event: "click",
                selector: elms.filterToggler,
                handler: this.onFilterToggler,
            },
            // Team overlay events
            {
                event: "click",
                selector: elms.goToJoinTeamBtn,
                handler: this.onGoToJoinTeam,
            },
            {
                event: "click",
                selector: elms.viewTeamBtn,
                handler: this.onViewTeam,
            },
            {
                event: "click",
                selector: elms.backBtn,
                handler: this.onClickBackBtn,
            },
            {
                event: "click",
                selector: elms.goToCreateTeamBtn,
                handler: this.onGoToCreateTeam,
            },
            {
                event: "click",
                selector: elms.closeCreateTeamBtn,
                handler: this.onClickCloseCreateTeamBtn,
            },
            {
                event: "input",
                selector: elms.teamNameInput,
                handler: this.onInputTeamName,
            },
            {
                event: "click",
                selector: elms.createConfirmBtn,
                handler: this.onCreateConfirm,
            },
            {
                event: "click",
                selector: elms.createBtn,
                handler: this.onCreateTeam,
            },
            {
                event: "click",
                selector: elms.closeConfirmBtn,
                handler: this.onClickCloseConfirmBtn,
            },
            {
                event: "click",
                selector: elms.joinConfirmBtn,
                handler: this.onJoinConfirm,
            },
            {
                event: "click",
                selector: elms.joinBtn,
                handler: this.onJoinTeam,
            },
            {
                event: "click",
                selector: elms.leaveTeamBtn,
                handler: this.onLeaveTeam,
            },
            {
                event: "click",
                selector: elms.leaveTeamConfirmBtn,
                handler: this.onConfirmLeaveTeam,
            },
            {
                event: "click",
                selector: elms.leaveTeamCancelBtn,
                handler: this.onCancelLeaveTeam,
            },
            {
                event: "click",
                selector: elms.removeMemberBtn,
                handler: this.onRemoveMember,
            },
            {
                event: "click",
                selector: elms.removeMemberConfirmBtn,
                handler: this.onConfirmRemoveMember,
            },
            {
                event: "click",
                selector: elms.removeMemberCancelBtn,
                handler: this.onCancelRemoveMember,
            },
            {
                event: "click",
                selector: elms.snackbarClose,
                handler: this.onCloseSnackbar,
            },
            {
                event: "click",
                selector: elms.closeBlockedBtn,
                handler: this.onCloseJoinBlocked,
            },
        ];
    }

    beforeInit() {
        this.render();
    }

    setPlaceholderTxt(content, placeholderTag, value) {
        return content.replace(placeholderTag, value);
    }

    async modifyData() { 
        const response = await this.fetchLeaderboard();

        if (!response || !response.leaderboard) {
            return this._data;
        }

        const {
            leaderboard,
            common_goals: commonGoals,
            current_competition: currentCompetition,
            team_list: teamList,
            is_in_team: isInTeam,
            max_team_members: maxTeamMembers,
            team_switch_limit: teamSwitchLimit,
        } = response;

        this._data.topTeamsLeaderboard = leaderboard.top_teams_leaderboard;
        this._data.currentTeamLeaderboard = leaderboard.current_team_leaderboard;

        if (commonGoals !== undefined) {
            this._data.common_goals = commonGoals;
        }
        if (currentCompetition !== undefined) {
            this._data.current_competition = currentCompetition;
        }
        if (teamList !== undefined) {
            this._data.team_list = teamList;
        }
        if (isInTeam !== undefined) {
            this._data.is_in_team = isInTeam;
        }
        if (maxTeamMembers !== undefined) {
            this._data.max_team_members = maxTeamMembers;
        }
        if (teamSwitchLimit !== undefined) {
            this._data.team_switch_limit = teamSwitchLimit;
        }

        let textSettings = this._data.text_settings;
        let leaveTeamPopup = textSettings.leave_team_popup;
        let createTeamPopup = textSettings.create_team_popup;
        let joinTeamPopup = textSettings.join_team_popup;

        createTeamPopup = {
            ...createTeamPopup,
            title: this.setPlaceholderTxt(
                createTeamPopup.title, 
                "{team}", 
                "<span class='create-team-popup__confirm-teamname js-confirm-teamname'>teamName</span>"
            ),
        };

        joinTeamPopup = {
            ...joinTeamPopup,
            title: this.setPlaceholderTxt(joinTeamPopup.title, 
                "{team}", 
                "<span class='teamlist-popup__confirm-teamname js-confirm-teamname'>teamName</span>"
            ),
        };

        leaveTeamPopup = {
            ...leaveTeamPopup,
            title: this.setPlaceholderTxt(leaveTeamPopup.title, 
                "{team}", 
                "<span class='team-detail__confirm-teamname js-confirm-teamname'>teamName</span>"
            ),
        };

        textSettings = {
            ...textSettings,
            create_team_popup: createTeamPopup,
            join_team_popup: joinTeamPopup,
            leave_team_popup: leaveTeamPopup,
            create_team_instruction: this.setPlaceholderTxt(
                textSettings.create_team_instruction, 
                "{create_team_link}", 
                `<button type='button' class='js-go-to-create-team'>${textSettings.create_team_button_text}</button>`
            ),
            join_team_instruction: this.setPlaceholderTxt(
                textSettings.join_team_instruction, 
                "{join_team_link}", 
                `<button type='button' class='js-go-to-join-team'>${textSettings.join_team_button_text}</button>`
            ),
        };

        this._data.text_settings = textSettings;

        return this._data;
    }

    async render() {
        const data = await this.modifyData();

        const htmlTemplate = $("#" + this.template).html();
        const html = compile(htmlTemplate, data);
        $(".app").html(html);

        this.setGameState();
    }

    setGameState() {
        const elms = this.elms;
        const $filterTogglerContainer = $(elms.filterTogglerContainer);
        
        $filterTogglerContainer.toggleClass("is-total-active", !this.isFilterActive);

        this.handleCompetitionCountdown();
    }

    async fetchLeaderboard() {
        const [response] = await bdjs.goAsync(
            bdapi.post("game/get-leaderboard", {
                is_filter_active: this.isFilterActive,
            }),
        );

        if (response?.data?.success) {
            return response?.data?.data;
        }

        return [];  
    }

    async fetchCurrentTeamMembersLeaderboard() {
        const [response] = await bdjs.goAsync(
            bdapi.post("game/view-current-team"),
        );

        if (response?.data?.success) {
            return response?.data?.data;
        }

        return [];
    }

    handleCompetitionCountdown() {
        const currentCompetition = this._data.current_competition;
        if(currentCompetition.length === 0) {
            return;
        }

        const { end_date: endDate } = currentCompetition;

        if(this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }

        // Competition end_date is Y-m-d H:i:s in CET (Europe/Amsterdam).
        const endDateObj = this.parseDateInTimezone(endDate, 'Europe/Amsterdam');

        const updateCountdown = () => {
            const timeDifference = endDateObj.getTime() - Date.now();

            if(timeDifference <= 0) {
                clearInterval(this.countdownInterval);
                this.countdownInterval = null;
                return;
            }

            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            // const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

            $(".js-countdown-day").text(days);
            $(".js-countdown-hour").text(hours);
            $(".js-countdown-minute").text(minutes);
        };

        updateCountdown();

        this.countdownInterval = setInterval(updateCountdown, 1000);
    }

    /**
     * Parse a wall-clock datetime string as a timezone-local instant.
     * @param {string} dateStr - "YYYY-MM-DD" or "YYYY-MM-DD HH:mm:ss"
     * @param {string} timeZone - IANA timezone (e.g. Europe/Amsterdam for CET/CEST)
     * @returns {Date}
     */
    parseDateInTimezone(dateStr, timeZone) {
        const [datePart, timePart = '00:00:00'] = String(dateStr).trim().replace('T', ' ').split(/\s+/);
        const [year, month, day] = datePart.split('-').map(Number);
        const [hour, minute, second = 0] = timePart.split(':').map(Number);

        const utcAsWall = Date.UTC(year, month - 1, day, hour, minute, second);
        const dtf = new Intl.DateTimeFormat('en-US', {
            timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hourCycle: 'h23',
        });

        const zonedAsUtc = (ms) => {
            const parts = Object.fromEntries(
                dtf.formatToParts(new Date(ms))
                    .filter((part) => part.type !== 'literal')
                    .map((part) => [part.type, part.value]),
            );
            const h = parts.hour === '24' ? 0 : Number(parts.hour);
            return Date.UTC(
                Number(parts.year),
                Number(parts.month) - 1,
                Number(parts.day),
                h,
                Number(parts.minute),
                Number(parts.second),
            );
        };

        // Convert wall time in `timeZone` to the correct UTC instant (handles CET/CEST).
        return new Date(utcAsWall - (zonedAsUtc(utcAsWall) - utcAsWall));
    }

    onSwitchTab(e, el) {
        const elms = this.elms;
        const $this = $(el);

        const tab = $this.data("tab");
        const isLeaderboardTab = tab === "leaderboard";
        const $pageScreen = $(elms.pageScreen);

        $pageScreen.toggleClass("is-goal-active", !isLeaderboardTab);
    }

    onFilterToggler(e, el) {
        const $this = $(el);
        const isFilterActive = $this.data("period");

        this.isFilterActive = isFilterActive;
        this.render();
    }

    // =========================================================================
    // Team Overlay Handlers
    // =========================================================================

    /**
     * Open join team list overlay.
     */
    onGoToJoinTeam() {
        const $pageScreen = $(this.elms.pageScreen);
        $pageScreen.removeClass("is-create-team-active is-your-team-active");
        $pageScreen.addClass("is-team-list-active");
    }

    /**
     * Open team detail overlay and render current team members.
     */
    onViewTeam() {
        const $pageScreen = $(this.elms.pageScreen);
        this.renderCurrentTeamMembers();
        $pageScreen.removeClass("is-team-list-active is-create-team-active");
        $pageScreen.addClass("is-your-team-active");
    }

    /**
     * Close all team overlays (back button).
     */
    onClickBackBtn() {
        $(this.elms.pageScreen).removeClass(
            "is-your-team-active is-team-list-active is-create-team-active"
        );
    }

    /**
     * Open create team overlay from team list.
     */
    onGoToCreateTeam() {
        const $pageScreen = $(this.elms.pageScreen);
        $pageScreen.removeClass("is-team-list-active is-your-team-active");
        $pageScreen.addClass("is-create-team-active");
    }

    /**
     * Navigate back from create team to team list.
     */
    onClickCloseCreateTeamBtn() {
        $(this.elms.pageScreen)
            .removeClass("is-create-team-active")
            .addClass("is-team-list-active");
    }

    onInputTeamName(e, el) {
        const $this = $(el);
        const teamName = String($this.val()).trim();
        const $createConfirmBtn = $(this.elms.createConfirmBtn);
        $createConfirmBtn.prop("disabled", teamName.length === 0);
    }

    onCreateConfirm() {
        const elms = this.elms;
        const teamName = String($(elms.teamNameInput).val()).trim();
        if (teamName.length === 0) return;

        $(elms.confirmTeamname).text(teamName);
        $(elms.createConfirmPopup).addClass("active");
    }

    async onCreateTeam() {
        const elms = this.elms;
        const teamName = String($(elms.teamNameInput).val()).trim();

        const [res] = await bdjs.goAsync(bdapi.post("game/create-team", {
            team_name: teamName,
        }));

        if (res.data.success) {
            $(elms.createConfirmPopup).removeClass("active");
            this.render();
        }
    }

    onClickCloseConfirmBtn(e, el) {
        const elms = this.elms;
        const $parent = $(el).parents(".confirm-popup");
        const isJoinConfirmPopup = $parent.hasClass("js-join-confirm-popup");

        if (isJoinConfirmPopup) {
            $(elms.joinConfirmPopup).removeClass("active");
        } else {
            $(elms.createConfirmPopup).removeClass("active");
        }
    }

    onJoinConfirm(e, el) {
        const elms = this.elms;
        const $this = $(el);
        if ($this.parent().hasClass("is-full")) return;

        const teamId = $this.parent().data("team-id");
        const teamName = $this.parent().data("team-name");

        $(elms.confirmTeamname).text(teamName);
        $(elms.joinConfirmPopup)
            .attr("data-team-id", teamId)
            .addClass("active");
    }

    async onJoinTeam() {
        const elms = this.elms;
        const $joinConfirmPopup = $(elms.joinConfirmPopup);
        const teamId = $joinConfirmPopup.data("team-id");

        const [res] = await bdjs.goAsync(bdapi.post("game/join-team", {
            team_id: teamId,
        }));

        if (res.data.success) {
            $joinConfirmPopup.removeClass("active");
            this.render();
        } else {
            const errorMsg = res.data.data.message;
            const { description, title } = errorMsg;
            const $joinBlockedPopup = $(elms.joinBlockedPopup);

            $joinBlockedPopup.find(".js-join-blocked-title").html(title);
            $joinBlockedPopup.find(".js-join-blocked-description").html(description);
            $joinBlockedPopup.addClass("active");
        }
    }

    onLeaveTeam() {
        const elms = this.elms;
        const $leaveTeamPopup = $(elms.leaveTeamPopup);
        const teamName = $(".team-detail__team-name-text").text().trim();

        $leaveTeamPopup.find(elms.confirmTeamname).text(teamName);
        $leaveTeamPopup.addClass("active");
    }

    onCancelLeaveTeam() {
        $(this.elms.leaveTeamPopup).removeClass("active");
    }

    async onConfirmLeaveTeam() {
        const [res] = await bdjs.goAsync(bdapi.post("game/leave-team"));

        if (res.data.success) {
            this.render();
            this.showSnackbar();
        }
    }

    onRemoveMember(e, el) {
        const elms = this.elms;
        const $memberItem = $(el).closest(".team-detail__member-item");
        const userId = $memberItem.data("user-id");
        const memberName = $memberItem.find(".team-detail__member-name").text().trim();

        const $removeMemberPopup = $(elms.removeMemberPopup);
        const $title = $removeMemberPopup.find(".js-remove-member-title");
        $title.text($title.text().replace("{player}", memberName));
        $removeMemberPopup.attr("data-user-id", userId).addClass("active");
    }

    async onConfirmRemoveMember() {
        const elms = this.elms;
        const $removeMemberPopup = $(elms.removeMemberPopup);
        const removedUserId = $removeMemberPopup.data("user-id");

        const [res] = await bdjs.goAsync(bdapi.post("game/remove-member-from-team", {
            removed_user_id: removedUserId,
        }));

        if (res.data.success) {
            $removeMemberPopup.removeAttr("data-user-id").removeClass("active");
            this.renderCurrentTeamMembers();
        }
    }

    onCancelRemoveMember() {
        $(this.elms.removeMemberPopup).removeAttr("data-user-id").removeClass("active");
    }

    onCloseJoinBlocked() {
        $(this.elms.joinBlockedPopup).removeClass("active");
        this.render();
    }

    /**
     * Show the bottom snackbar and auto-dismiss after delay.
     * @param {number} duration - Auto-dismiss delay in ms (default 4000).
     */
    showSnackbar(duration = 4000) {
        const $snackbar = $(this.elms.snackbar);
        $snackbar.addClass("active");

        if (this._snackbarTimer) {
            clearTimeout(this._snackbarTimer);
        }

        this._snackbarTimer = setTimeout(() => {
            $snackbar.removeClass("active");
            this._snackbarTimer = null;
        }, duration);
    }

    onCloseSnackbar() {
        $(this.elms.snackbar).removeClass("active");
        if (this._snackbarTimer) {
            clearTimeout(this._snackbarTimer);
            this._snackbarTimer = null;
        }
    }

    /**
     * Fetch and render current team members into the team detail popup.
     */
    async renderCurrentTeamMembers() {
        const currentTeamMembers = await this.fetchCurrentTeamMembersLeaderboard();
        const htmlTemplate = $("#team-detail-template").html();
        const data = {
            ...currentTeamMembers,
            text_settings: this._data.text_settings,
        };
        const html = compile(htmlTemplate, data);
        $(this.elms.teamDetailPopup).html(html);
    }

    beforeDestroy() {
        if(this.countdownInterval) {
            clearInterval(this.countdownInterval);
            this.countdownInterval = null;
        }
    }
}
